import { useSelector } from 'react-redux'
import ClassicBettingCard from './ClassicBettingCard'
import { PANELS } from '@constants/bettingConstants'

const ClassicBettingController = () => {
  const { classic, divider } = useSelector((state) => state.layout.duelBetMode)

  return (
    <div className="standard-normal-classic-betting-controller-outer-container">
      <div className="standard-normal-classic-betting-controller-inner-container">
        <div className="standard-normal-classic-betting-card">
          <ClassicBettingCard panel={PANELS.ONE} />
        </div>
        {divider && <div className="standard-normal-classic-betting-controller-divider" />}
        {classic && (
          <div className="standard-normal-classic-betting-card">
            <ClassicBettingCard panel={PANELS.TWO} />
          </div>
        )}
      </div>
    </div>
  )
}
export default ClassicBettingController
